import { BodyNormal, LinkButton } from '@atlassian/mpac-primitives';
import { CloudSecurityParticipantIcon } from '@atlassian/mpac-ui';
import React from 'react';
import { ContentHeader, ContentItems, ContentWrapper, Heading, Label } from './Certification.styles';
import ShieldIcon from '../../assets/shield.svg';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const bugBountyLink = 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program';
export const CloudSecurityParticipantContent = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ContentHeader, {
      children: [/*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
        label: "Cloud Security Participant badge",
        primaryColor: "var(--ds-icon-brand)"
      }), /*#__PURE__*/_jsx(Heading, {
        children: "CLOUD SECURITY PARTICIPANT"
      })]
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(BodyNormal, {
        children: "This app offers verified security through:"
      }), /*#__PURE__*/_jsx(ContentItems, {
        children: /*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx("img", {
            src: ShieldIcon,
            alt: "shield-icon"
          }), /*#__PURE__*/_jsx(Label, {
            children: "Participation in the Marketplace Bug Bounty program"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(LinkButton, {
      target: "_blank",
      href: bugBountyLink,
      children: "About the Marketplace Bug Bounty program"
    })]
  });
};